import {
  FetchEventProps,
  fetchAllEvents,
  fetchAllEventsAfterGivenDate,
} from "../api/match_events";
import { GaripalliDirectusClient } from "../directus/client";
import { MatchEvent } from "../directus/collections";
import { GaripalliIDB } from "../extensions/idb";
import { calculateEventsTimeDiffs } from "../libs/gameAnalysis/utils";

export async function getAllEvents(
  client: GaripalliDirectusClient,
  db: GaripalliIDB,
  props?: Omit<FetchEventProps, "limit" | "offset">
): Promise<MatchEvent[]> {
  let events = await db.getAll("match_events");
  // if (!events?.length) {
  //   events = await fetchAllEvents(client, props);
  //   db.add("match_events", ...events);
  // }

  return events;
}

export async function syncEvents(
  client: GaripalliDirectusClient,
  db: GaripalliIDB
) {
  const syncMetadataStore = db.objectStore("sync_metadata");
  const eventsStore = db.objectStore("match_events");
  const lastEventFetchedId = (await syncMetadataStore.get("lastSync"))
    ?.match_events.lastItemId;
  const lastEvent = lastEventFetchedId
    ? await eventsStore.get(lastEventFetchedId)
    : undefined;

  let events: MatchEvent[] = [];
  if (lastEvent) {
    events = await fetchAllEventsAfterGivenDate(client, lastEvent.date_created);
  } else {
    events = await fetchAllEvents(client);
    await eventsStore.clear();
  }

  eventsStore.bulkAdd(events);

  const newLastEvent = events.sort(calculateEventsTimeDiffs)[events.length - 1];

  if (newLastEvent) {
    await syncMetadataStore.update("lastSync", (data) => ({
      ...data,
      match_events: {
        lastItemId: newLastEvent.id,
        lastSyncedAt: Date.now(),
      },
    }));
  }

  return events;
}

export async function getLastStoredTimelineEntryForMatch(
  db: GaripalliIDB,
  matchId: string
) {
  const store = db.objectStore("timelines");
  if (!store) {
    throw new Error("Object store `timelines` not found.");
  }
  const index = store.index("matchByDate", "readonly");
  const range = IDBKeyRange.bound([matchId, 0], [matchId, Infinity]);
  return await index.last(range);
}
